// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-item[data-v-3e936e15]{transition:all 1s;display:inline-block;width:100%}.list-enter-from[data-v-3e936e15]{opacity:0;transform:translateY(-30px)}.list-leave-to[data-v-3e936e15]{opacity:0;transform:translateX(80%)}.list-leave-active[data-v-3e936e15]{position:fixed}.list-move[data-v-3e936e15]{transition:all 1s}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
